(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astra-collection"]) return;
  try {
    
document.addEventListener('click',event=>{
 const link=event.target.closest('a[data-lab-brand]');
 if(!link||event.defaultPrevented||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
 const destination=new URL(link.href,window.location.origin);
 const current=new URLSearchParams(window.location.search);
 for(const [key,value] of current){if(key.startsWith('filter.')||key==='sort_by'||key==='lab_q')destination.searchParams.append(key,value);}
 event.preventDefault();window.location.assign(destination.href);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astra-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-perfume-motion-toggle]');
  if (!button) return;
  const hero = button.closest('[data-cinema]');
  if (!hero) return;
  const paused = hero.dataset.paused !== 'true';
  hero.dataset.paused = String(paused);
  button.setAttribute('aria-pressed', String(paused));
  button.textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-footer"]) return;
  try {
    

(()=>{
 const mobile=window.matchMedia('(max-width: 700px)');
 const roots=new Set();
 function sync(root){root.querySelectorAll('.lab-footer-group').forEach(group=>{group.open=!mobile.matches||root.dataset.mobileCollapse!=='true';group.querySelector('summary').tabIndex=mobile.matches?0:-1;});}
 function init(scope){scope.querySelectorAll('[data-lab-footer]').forEach(root=>{if(roots.has(root))return;roots.add(root);sync(root);root.querySelectorAll('.lab-footer-group>summary').forEach(summary=>summary.addEventListener('click',e=>{if(!mobile.matches)e.preventDefault();}));});}
 mobile.addEventListener('change',()=>roots.forEach(root=>{if(root.isConnected)sync(root);else roots.delete(root);}));
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:block:select',e=>{const group=e.target.closest('.lab-footer-group');if(group)group.open=true;});
 init(document);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
